var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoggedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "user-lock",
    className: "icon_logged_in_svg__svg-inline--fa icon_logged_in_svg__fa-user-lock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M592 288h-16v-75.3c0-41.84-30.03-80.04-71.66-84.27C456.5 123.6 416 161.1 416 208v80h-16c-26.4 0-48 21.6-48 48v128c0 26.4 21.6 48 48 48h192c26.4 0 48-21.6 48-48V336c0-26.4-21.6-48-48-48zm-96 144c-17.62 0-32-14.38-32-32s14.38-32 32-32 32 14.38 32 32-14.4 32-32 32zm32-144h-64v-80c0-17.62 14.38-32 32-32s32 14.38 32 32v80zm-304-32c70.7 0 128-57.31 128-128S294.7 0 224 0 96 57.31 96 128s57.3 128 128 128zm96 80c0-8.672 1.738-16.87 4.303-24.7C308.6 306.6 291.9 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4 0 496.5 15.52 512 34.66 512h301.7C326.3 498.6 320 482.1 320 464V336z"
  })));
}
export default SvgIconLoggedIn;